import { render } from "./TestEditor.vue?vue&type=template&id=38d1c69d&scoped=true"
import script from "./TestEditor.vue?vue&type=script&lang=js"
export * from "./TestEditor.vue?vue&type=script&lang=js"

import "./TestEditor.vue?vue&type=style&index=0&id=38d1c69d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d1c69d"]])

export default __exports__